export const DEFAULT_PROJECT_IMAGE = '//julietacontreras.pro/images/bloc2/bloc2.png';
export const DEFAULT_PROJECT_IMAGE2 = '//julietacontreras.pro/images/map.png';
